/* Build Your Bundle v3 — item list on a product page with free-gift unlocks. */
(function () {
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }

  // ── Build Your Bundle free-gift logic (Gift Logic spec v1.0) ─────────────────────────────
  // KEEP IN SYNC with the identical function in build-your-bundle.js. Single source of truth for
  // how many gifts a cart earns and which ones, so V1/V2/V3 can never drift apart.
  //   • Free shipping: 1+ Clean Towel OR 2+ Makeup Wipes.
  //   • Quantity gifts: foundation count (wipes + towels) — 6+ → 2, 4+ → 1, else 0.
  //   • A container adds +1 and an extra adds +1 on top; the total is capped at 2.
  //   • Fixed order (no customer choice): gift #1 is always DermaDot, gift #2 is always Travel.
  //   • The Luxe Bamboo Box's 50 free towels are a separate bonus, outside the 2-gift cap.
  function computeBybGifts(input) {
    var wipeQty = input.wipeQty || 0;
    var towelQty = input.towelQty || 0;
    var freeShipping = towelQty >= 1 || wipeQty >= 2;
    var foundationCount = wipeQty + towelQty;
    var qtyGifts = foundationCount >= 6 ? 2 : (foundationCount >= 4 ? 1 : 0);
    var addOnGifts = (input.hasContainer ? 1 : 0) + (input.hasExtra ? 1 : 0);
    var totalGifts = Math.min(qtyGifts + addOnGifts, 2);
    var gifts = [];
    if (totalGifts >= 1) gifts.push('dermadot'); // 1st is always DermaDot
    if (totalGifts >= 2) gifts.push('travel');   // 2nd is always Travel
    return {
      freeShipping: freeShipping,
      foundationCount: foundationCount,
      totalGifts: totalGifts,
      gifts: gifts,
      luxeBonus: !!input.isLuxeBox
    };
  }
  // Map a bundle role to the fixed gift it grants. DermaDot rides the 'extra' slot, Travel the
  // 'container' slot (matches the section config), but identity is fixed by the spec, not the role.
  function giftKeyForRole(role) {
    if (role === 'extra') return 'dermadot';
    if (role === 'container') return 'travel';
    return null;
  }

  function initV3(root) {
    if (!root || root.getAttribute('data-v3-init') === 'true') return;
    root.setAttribute('data-v3-init', 'true');

    var discountCode = root.getAttribute('data-discount-code') || '';
    // Cart line property identifying which bundle page built the cart (e.g. MURW_v3).
    var bundleId = root.getAttribute('data-bundle-id') || '';
    function giftLineProps() {
      var p = { _byb: 'gift', _byb_gift: 'true' };
      if (bundleId) p.Bundle = bundleId;
      return p;
    }
    var items = [].slice.call(root.querySelectorAll('[data-byb3-item]'));
    // Each divider heads a group; tag it with the role of the first item that follows so the
    // whole group (heading + items) can be dimmed together while it's locked.
    var dividers = [].slice.call(root.querySelectorAll('.byb3-divider'));
    dividers.forEach(function (d) {
      var el = d.nextElementSibling;
      while (el && !el.hasAttribute('data-byb3-item')) el = el.nextElementSibling;
      d._role = el ? el.getAttribute('data-role') : null;
    });
    var gifts = [].slice.call(root.querySelectorAll('[data-byb3-gift]'));
    var unlockedNumEl = root.querySelector('[data-byb3-unlocked]');
    var summaryEl = root.querySelector('[data-byb3-summary]');
    var savingsEl = root.querySelector('[data-byb3-savings]');
    var checkoutBtn = root.querySelector('[data-byb3-checkout]');
    var hintEl = root.querySelector('[data-byb3-hint]');
    // Subscribe & Save toggle (defaults to subscription when present).
    var subWrap = root.querySelector('[data-byb3-sub]');
    var subActive = !!subWrap;
    // Lock/unlock the subscribe / one-time toggle (used while a checkout redirect is in flight).
    function setSubDisabled(disabled) {
      if (!subWrap) return;
      subWrap.classList.toggle('is-checkout-loading', disabled);
      subWrap.querySelectorAll('input[type=radio]').forEach(function (r) { r.disabled = disabled; });
    }
    var ctaLabel = 'Checkout';
    var emptyLabel = checkoutBtn ? checkoutBtn.textContent.trim() : 'Select your items';

    // Subscribe & Save badge: flat "EXTRA 20% OFF".
    if (subWrap) {
      var upToEl = subWrap.querySelector('.save-upto');
      if (upToEl) upToEl.textContent = 'EXTRA 20% OFF';
    }

    // ---- Pick-your-gift (slot-pool, mirrors build-your-bundle.js) ----
    var gwpCollection = root.querySelector('[data-byb3-gwp-collection]');
    var gwpCards = gwpCollection ? [].slice.call(gwpCollection.querySelectorAll('[data-byb3-gwp-card]')) : [];
    var gwpCountEl = root.querySelector('[data-byb3-gwp-count]');
    // Monotonic pick counter so chosen gifts fill in selection order, not DOM order.
    var gwpPickSeq = 0;
    function pickSeqOf(card) { return parseInt(card.getAttribute('data-pick-seq'), 10) || 0; }
    function pickSeqSort(a, b) { return pickSeqOf(a) - pickSeqOf(b); }

    // ---- Gallery — the exact same Flickity slideshow as product-hero (theme.Slideshow wraps
    // the slides in .flickity-viewport, adds the standard flickity prev/next buttons, and drives
    // the product__thumbs childNav: thumb clicks, thumb arrows, active-thumb scroll sync). ----
    root.querySelectorAll('[data-byb3-gallery]').forEach(function (gallery) {
      var slider = gallery.querySelector('[data-byb3-photos]');
      if (!slider) return;
      var slideEls = slider.querySelectorAll('.byb3-slide');
      if (slideEls.length <= 1) {
        if (slideEls[0]) slideEls[0].classList.add('is-selected');
        return;
      }
      if (!(window.theme && theme.Slideshow)) return;
      var thumbs = gallery.querySelector('[data-byb3-thumbs]');
      new theme.Slideshow(slider, {
        dragThreshold: 25,
        adaptiveHeight: true,
        avoidReflow: true,
        childNav: thumbs,
        childNavScroller: thumbs ? thumbs.querySelector('.product__thumbs--scroller') : null,
        childVertical: false,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true
      });

      // With few thumbnails (strip doesn't overflow) the thumb arrows serve no purpose — hide both.
      var thumbScroller = thumbs ? thumbs.querySelector('.product__thumbs--scroller') : null;
      var thumbArrows = thumbs ? [].slice.call(thumbs.querySelectorAll('.product__thumb-arrow')) : [];
      if (thumbScroller && thumbArrows.length) {
        var syncThumbArrows = function () {
          var overflow = thumbScroller.scrollWidth > thumbScroller.clientWidth + 1;
          thumbArrows.forEach(function (a) { a.classList.toggle('is-hidden', !overflow); });
        };
        syncThumbArrows();
        window.addEventListener('resize', syncThumbArrows);
      }
    });

    function qtyOf(item) { return parseInt(item.getAttribute('data-qty') || '0', 10); }

    // Keep each item's displayed price in sync with the Subscribe & Save toggle. Sub-eligible
    // items show the real selling-plan price (with the regular price struck through); one-time
    // reverts to the full price (with any product-discount strike).
    function updateItemPrices() {
      items.forEach(function (it) {
        var nowEl = it.querySelector('[data-byb3-price-now]');
        if (!nowEl) return;
        var wasEl = it.querySelector('[data-byb3-price-was]');
        var base = parseInt(it.getAttribute('data-price'), 10) || 0;
        var strike = parseInt(it.getAttribute('data-strike'), 10) || 0;
        var subPrice = parseInt(it.getAttribute('data-sub-price'), 10) || 0;
        var subOn = subActive && it.getAttribute('data-sub-display') === 'true' && subPrice > 0 && subPrice < base;
        var now = subOn ? subPrice : base;
        var was = subOn ? base : strike;
        nowEl.textContent = money(now);
        if (wasEl) {
          if (was > now) { wasEl.textContent = money(was); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
        // "% OFF" badge under the price reflects the currently displayed discount.
        var saveEl = it.querySelector('[data-byb3-save]');
        if (saveEl) {
          if (was > now) { saveEl.textContent = Math.round((was - now) * 100 / was) + '% OFF'; saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
      });
    }
    function roleQty(role) {
      var n = 0;
      items.forEach(function (it) { if (it.getAttribute('data-role') === role) n += qtyOf(it); });
      return n;
    }

    // Progressive gating: Makeup Wipes are required first, then Clean Towels; only once a
    // towel is picked do Containers and Extras become selectable. Everything else is open.
    function isRoleUnlocked(role) {
      if (role === 'towel') return roleQty('murw') > 0;
      // 2+ wipes waive the Clean Towel requirement, so Containers/Extras open without a towel.
      if (role === 'container' || role === 'extra') return roleQty('towel') > 0 || roleQty('murw') >= 2;
      return true;
    }

    function lbbQty() {
      var n = 0;
      items.forEach(function (it) { if (it.getAttribute('data-lbb') === 'true') n += qtyOf(it); });
      return n;
    }
    // Volume rule: wipes alone can unlock gift tiers — 2+ wipes unlock the towel tier (Free
    // Shipping), 4+ wipes unlock the container tier — no towel/container needed.
    function wipeUnlocksTier(role) {
      var wipeQty = roleQty('murw');
      if (role === 'towel') return wipeQty >= 2;
      if (role === 'container') return wipeQty >= 4;
      return false;
    }
    // Current earned-gift set from the live cart (spec v1.0). Cheap; recomputed where needed so
    // the bar boxes, pick cards and checkout can never disagree.
    function currentGiftResult() {
      return computeBybGifts({
        wipeQty: roleQty('murw'),
        towelQty: roleQty('towel'),
        hasContainer: roleQty('container') > 0,
        hasExtra: roleQty('extra') > 0,
        isLuxeBox: lbbQty() > 0
      });
    }
    function giftEarned(key) { return currentGiftResult().gifts.indexOf(key) >= 0; }
    function giftUnlocked(gift, totalCount) {
      var role = gift.getAttribute('data-unlock-role') || 'any';
      var threshold = parseInt(gift.getAttribute('data-threshold'), 10) || 1;
      if (role === 'lbb') return lbbQty() > 0; // only a Luxe Bamboo box unlocks it
      var giftKey = giftKeyForRole(role);
      if (giftKey) return giftEarned(giftKey); // DermaDot/Travel follow the spec earned-gift set
      if (wipeUnlocksTier(role)) return true;
      if (role === 'towel' || role === 'container' || role === 'murw' || role === 'extra') return roleQty(role) > 0;
      return totalCount >= threshold; // "any": by total item count
    }
    // Single source of truth for a slot condition (bar gifts + pick-your-gift cards share it).
    function isUnlocked(role, threshold, count) {
      if (role === 'lbb') return lbbQty() > 0;
      var giftKey = giftKeyForRole(role);
      if (giftKey) return giftEarned(giftKey); // DermaDot/Travel follow the spec earned-gift set
      if (wipeUnlocksTier(role)) return true;
      if (role && role !== 'any' && role !== 'none') return roleQty(role) > 0;
      if (threshold) return count >= threshold;
      return count > 0;
    }
    var gwpTickSvg = '<svg class="byb3-gwp-tick" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5 10 17.5 19 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    // Gifts are auto-added, so the toggle is inert: show an "Added" tick on an earned gift and
    // hide the button entirely otherwise (no "+ Add FREE" affordance — spec §2).
    function syncGwpBtn(btn) {
      var added = btn.classList.contains('is-added');
      btn.innerHTML = added ? (gwpTickSvg + '<span>Added</span>') : '';
      btn.style.display = added ? '' : 'none';
    }
    function gwpUnlockedSlots() {
      return currentGiftResult().totalGifts;
    }
    function gwpChosenCount() {
      return gwpCards.filter(function (card) {
        var b = card.querySelector('[data-byb3-gwp-toggle]');
        return b && b.classList.contains('is-added') && card.getAttribute('data-gwp-variant');
      }).length;
    }
    function giftsPendingLabel(slots, chosen) {
      var remaining = slots - chosen;
      if (remaining === 1) return 'Pick your free gift to continue';
      return 'Pick ' + remaining + ' free gifts to continue';
    }
    function scrollToGwp() {
      var target = root.querySelector('#byb3-pick-gwp') || gwpCollection;
      if (!target) return;
      var bar = root.querySelector('.byb3-gifts');
      var offset = (bar && getComputedStyle(bar).position === 'sticky') ? bar.offsetHeight + 12 : 12;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
    // Mirror picked gifts up into the bar's "Pick your gift" boxes (v1 parity):
    // the box shows the chosen gift's photo + FREE value once a matching pick is made.
    function syncBarPicks(pickedCards) {
      var pool = pickedCards.slice();
      gifts.forEach(function (g) {
        if (!g.classList.contains('byb3-gift--pick')) return;
        var role = g.getAttribute('data-unlock-role');
        var card = null;
        for (var i = 0; i < pool.length; i++) {
          if (pool[i].getAttribute('data-gwp-role') === role) { card = pool.splice(i, 1)[0]; break; }
        }
        g.classList.toggle('is-picked', !!card);
        var media = g.querySelector('.byb3-gift-media');
        var photo = media ? media.querySelector('.byb3-gift-photo') : null;
        var strike = g.querySelector('[data-byb3-gift-value]');
        var labelEl = g.querySelector('.byb3-gift-label');
        if (labelEl && g._origLabel == null) g._origLabel = labelEl.innerHTML; // remember "Pick your gift"
        if (card && media) {
          var src = card.getAttribute('data-gwp-image') || '';
          if (src) {
            if (!photo) {
              photo = document.createElement('img');
              photo.className = 'byb3-gift-photo';
              photo.alt = '';
              media.appendChild(photo);
            }
            if (photo.getAttribute('src') !== src) photo.setAttribute('src', src);
          }
          if (strike) strike.textContent = card.getAttribute('data-gwp-value') || '';
          // Show the picked gift's name under the box (v1 parity).
          if (labelEl) {
            var nmEl = card.querySelector('.byb3-item-name');
            var nm = nmEl ? nmEl.textContent.trim() : '';
            labelEl.innerHTML = '<a href="#byb3-pick-gwp">' + (nm || g._origLabel) + '</a>';
          }
        } else {
          if (photo) photo.remove();
          if (strike) strike.textContent = '';
          if (labelEl && g._origLabel != null) labelEl.innerHTML = g._origLabel;
        }
      });
    }
    // Slot-pool: every pick-your-gift card whose rule is met grants ONE fungible slot; slots
    // are spent on ANY gift, and picks beyond the current slot count are dropped (in reverse
    // pick order) so the tally never exceeds what's unlocked.
    function updateGwp(count) {
      if (!gwpCards.length) return;
      // Deterministically select exactly the earned gift cards (auto-add, no manual pick). The
      // earned set is fixed by the spec — gift #1 DermaDot ('extra' slot), gift #2 Travel ('container').
      var earnedGifts = currentGiftResult().gifts;
      gwpCards.forEach(function (card) {
        var abtn = card.querySelector('[data-byb3-gwp-toggle]');
        if (!abtn) return;
        var key = giftKeyForRole(card.getAttribute('data-gwp-role'));
        var earned = !!key && earnedGifts.indexOf(key) >= 0 && !!card.getAttribute('data-gwp-variant');
        if (earned) {
          if (!abtn.classList.contains('is-added')) { abtn.classList.add('is-added'); card.setAttribute('data-pick-seq', String(++gwpPickSeq)); }
        } else if (abtn.classList.contains('is-added')) {
          abtn.classList.remove('is-added'); card.removeAttribute('data-pick-seq');
        }
      });
      var unlockedSlots = currentGiftResult().totalGifts;
      // Dim the whole Free Gifts section (incl. its divider) while nothing is unlocked yet.
      if (gwpCollection) gwpCollection.classList.toggle('is-locked', unlockedSlots === 0);
      var addedCards = gwpCards.filter(function (card) {
        var b = card.querySelector('[data-byb3-gwp-toggle]');
        return b && b.classList.contains('is-added') && card.getAttribute('data-gwp-variant');
      }).sort(pickSeqSort);
      var chosen = addedCards.length;
      gwpCards.forEach(function (card) {
        var btn = card.querySelector('[data-byb3-gwp-toggle]');
        if (!btn) return;
        var isAdded = btn.classList.contains('is-added') && !!card.getAttribute('data-gwp-variant');
        btn.disabled = true; // auto-add — no manual pick
        card.classList.toggle('block_locked', !isAdded);
        card.classList.toggle('is-added', isAdded);
        syncGwpBtn(btn);
      });
      if (gwpCountEl) gwpCountEl.textContent = chosen + '/' + gwpCards.length;
      syncBarPicks(addedCards);
    }

    function update() {
      // Progressive gating pass. Reset any item whose prerequisite was removed (so a stray
      // towel/container can't survive after its wipe/towel is deselected), then dim + lock it.
      // Items are in dependency order in the DOM (wipes → towels → containers/extras), so a
      // single pass resolves the chain correctly.
      items.forEach(function (it) {
        var unlocked = isRoleUnlocked(it.getAttribute('data-role'));
        if (!unlocked && qtyOf(it) > 0) {
          it.setAttribute('data-qty', '0');
          var v = it.querySelector('[data-byb3-qval]'); if (v) v.textContent = '0';
          var incEl = it.querySelector('[data-byb3-inc]'); if (incEl) incEl.disabled = false;
        }
        it.classList.toggle('byb3-item--locked', !unlocked);
      });
      dividers.forEach(function (d) {
        d.classList.toggle('byb3-divider--locked', d._role ? !isRoleUnlocked(d._role) : false);
      });

      // Only one container total: once one is chosen, disable the others' Add buttons.
      var containerChosen = roleQty('container') > 0;
      items.forEach(function (it) {
        if (it.getAttribute('data-role') !== 'container') return;
        var blocked = containerChosen && qtyOf(it) === 0;
        it.classList.toggle('byb3-item--blocked', blocked);
        var ab = it.querySelector('[data-byb3-add]');
        if (ab) ab.disabled = blocked;
      });

      updateItemPrices();
      var totalCount = 0, subtotal = 0, subSavings = 0, msrpTotal = 0;
      items.forEach(function (it) {
        var n = qtyOf(it);
        totalCount += n;
        var price = parseInt(it.getAttribute('data-price'), 10) || 0;
        subtotal += n * price;
        // Full "before" value: the MSRP strike when one exists, else the regular price.
        var strike = parseInt(it.getAttribute('data-strike'), 10) || 0;
        msrpTotal += n * Math.max(strike, price);
        // Subscribe & Save savings — the real gap between the full price and the selling-plan
        // allocation price, counted only while subscription is active.
        if (subActive && it.getAttribute('data-sub-display') === 'true') {
          var sp = parseInt(it.getAttribute('data-sub-price'), 10) || 0;
          if (sp > 0 && sp < price) subSavings += n * (price - sp);
        }
        it.classList.toggle('is-added', n > 0);
      });
      var payable = subtotal - subSavings;

      var unlocked = 0, shippingSavings = 0, giftSavings = 0;
      gifts.forEach(function (g) {
        var on = giftUnlocked(g, totalCount);
        g.classList.toggle('is-unlocked', on);
        g.classList.toggle('is-locked', !on);
        // Pick-your-gift boxes unlock by earned-gift COUNT (gift #1 then #2), not by which add-on
        // was added — so a static "[Add a container]" hint goes stale once a container is in. Point
        // the still-locked box at the add-on that actually earns the next gift (containers cap at 1,
        // so once one's in prompt an extra, and vice-versa).
        if (!on && g.getAttribute('data-is-pick') === 'true') {
          var lockedHintEl = g.querySelector('[data-byb3-gift-locked]');
          if (lockedHintEl) {
            var hasContainerNow = roleQty('container') > 0, hasExtraNow = roleQty('extra') > 0;
            var nextAddOnHint = (hasContainerNow && !hasExtraNow) ? 'Add an extra' : (hasExtraNow && !hasContainerNow) ? 'Add a container' : 'Add a container or extra';
            lockedHintEl.textContent = '[' + nextAddOnHint + ']';
          }
        }
        // Unlocked gift values feed the savings breakdown. Pick-boxes are skipped here —
        // their value is counted from the actually-picked GWP cards below.
        if (on && g.getAttribute('data-is-pick') !== 'true') {
          var gv = parseInt(g.getAttribute('data-value'), 10) || 0;
          if (g.getAttribute('data-is-shipping') === 'true') shippingSavings += gv;
          else giftSavings += gv;
        }
        // Hidden-until-unlock gifts (e.g. 50 FREE Clean Towels) stay out of the bar until
        // unlocked and never count toward the x/N tally — N excludes them too (v1 parity).
        if (g.getAttribute('data-hidden-until-unlock') === 'true') {
          g.classList.toggle('byb3-gift-hidden', !on);
        } else if (on) {
          unlocked++;
        }
      });
      if (unlockedNumEl) unlockedNumEl.textContent = unlocked;

      // Size the gift-box row to however many boxes are actually visible (e.g. 3 → wider,
      // 4 → narrower when the bonus reveals), same as build-your-bundle.js.
      var visibleGifts = gifts.filter(function (g) { return !g.classList.contains('byb3-gift-hidden'); }).length;
      if (visibleGifts > 0) root.style.setProperty('--b3-gift-cols', visibleGifts);

      updateGwp(totalCount);

      // Value of the free gifts the customer actually picked (data-gwp-value is "$6" etc.).
      // Counted after updateGwp() so dropped surplus picks are excluded.
      gwpCards.forEach(function (card) {
        var b = card.querySelector('[data-byb3-gwp-toggle]');
        if (b && b.classList.contains('is-added')) {
          giftSavings += Math.round((parseFloat(String(card.getAttribute('data-gwp-value') || '').replace(/[^0-9.]/g, '')) || 0) * 100);
        }
      });

      // Checkout requires the foundation: a Makeup Wipe (step 1) AND a Clean Towel (step 2) —
      // except 2+ wipes waive the towel requirement (towelOk).
      var hasMurw = roleQty('murw') > 0;
      var hasTowel = roleQty('towel') > 0;
      var towelOk = hasTowel || roleQty('murw') >= 2;
      var giftSlots = gwpUnlockedSlots(totalCount);
      var giftPicked = gwpChosenCount();
      // Free gifts are auto-picked, so they never block checkout (the customer needn't pick).
      var giftsReady = true;
      var ready = hasMurw && towelOk && giftsReady;

      // Total-savings card (with breakdown), shown above the subscribe block (v1 parity).
      var discountSavings = Math.max(0, msrpTotal - subtotal); // container / product markdowns
      var totalSave = giftSavings + shippingSavings + discountSavings + subSavings;
      if (savingsEl) {
        if (ready && totalSave > 0) {
          var savingsRow = function (label, amt) { return '<div class="byb3-savings-row"><span>' + label + '</span><span class="byb3-savings-amt">-' + money(amt) + '</span></div>'; };
          var rows = '';
          if (giftSavings > 0) rows += savingsRow('Free gifts', giftSavings);
          if (shippingSavings > 0) rows += savingsRow('Free shipping', shippingSavings);
          if (discountSavings > 0) rows += savingsRow('Product discounts', discountSavings);
          if (subSavings > 0) rows += savingsRow('Subscribe &amp; Save', subSavings);
          var beforePrice = payable + totalSave;
          // Percentage saved vs. the full "before" value of this bundle.
          var savePct = beforePrice > 0 ? Math.round(totalSave * 100 / beforePrice) : 0;
          savingsEl.innerHTML =
            '<div class="byb3-savings-head"><span class="byb3-savings-title">TOTAL SAVINGS</span>' +
            '<span class="byb3-savings-total">' + money(totalSave) + '</span></div>' +
            (rows ? '<div class="byb3-savings-rows">' + rows + '</div>' : '') +
            '<div class="byb3-savings-total-row"><span>Total</span><span>' +
            (beforePrice > payable ? '<s class="byb3-savings-was">' + money(beforePrice) + '</s> ' : '') +
            '<span class="byb3-savings-now">' + money(payable) + '</span></span></div>' +
            (savePct > 0 ? '<p class="byb3-savings-pct">You’re saving <b>' + savePct + '%</b> on this bundle</p>' : '');
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }

      if (checkoutBtn) {
        if (checkoutBtn.classList.contains('is-checkout-redirecting')) return;
        // Not-ready state uses a class (not the native `disabled`) so the button still receives
        // clicks — clicking it then scrolls the user to the first unmet step.
        checkoutBtn.classList.toggle('is-disabled', !ready);
        checkoutBtn.classList.toggle('is-gifts-pending', hasMurw && towelOk && !giftsReady);
        if (ready) {
          // Show the savings: full "before" value (products at full price + free-gift value)
          // struck through next to the payable total (v1 parity).
          var beforeTotal = payable + totalSave;
          var wasHtml = beforeTotal > payable ? '<s class="byb3-checkout-was">' + money(beforeTotal) + '</s> ' : '';
          // Corner "SAVE X%" badge — same percentage as the TOTAL SAVINGS card (v1 parity).
          var btnPct = beforeTotal > 0 ? Math.round(totalSave * 100 / beforeTotal) : 0;
          var saveHtml = btnPct > 0 ? '<span class="byb3-checkout-save">SAVE ' + btnPct + '%</span>' : '';
          checkoutBtn.innerHTML = '<span class="byb3-checkout-main">' + ctaLabel + ' ' + wasHtml + '<span class="byb3-checkout-total">' + money(payable) + '</span></span>' + saveHtml;
        } else if (totalCount === 0) {
          checkoutBtn.innerHTML = '<span class="byb3-checkout-label">' + emptyLabel + '</span>';
        } else if (!hasMurw) {
          checkoutBtn.innerHTML = '<span class="byb3-checkout-label">Add a Makeup Wipe to continue</span>';
        } else if (!towelOk) {
          checkoutBtn.innerHTML = '<span class="byb3-checkout-label">Add a Clean Towel to continue</span>';
        } else {
          checkoutBtn.innerHTML = '<span class="byb3-checkout-label">' + giftsPendingLabel(giftSlots, giftPicked) + '</span>';
        }
      }
      if (summaryEl) {
        if (totalCount > 0) {
          summaryEl.hidden = false;
          summaryEl.innerHTML = totalCount + ' item' + (totalCount > 1 ? 's' : '') + (unlocked > 0 ? ' · ' + unlocked + ' free gift' + (unlocked > 1 ? 's' : '') + ' unlocked' : '');
        } else {
          summaryEl.hidden = true;
        }
      }
      if (hintEl) {
        if (ready) {
          hintEl.hidden = true;
        } else if (totalCount > 0) {
          hintEl.hidden = false;
          if (!hasMurw && !towelOk) hintEl.textContent = 'Add a Makeup Wipe and a Clean Towel to continue';
          else if (!hasMurw) hintEl.textContent = 'Add a Makeup Wipe to continue';
          else if (!towelOk) hintEl.textContent = 'Add a Clean Towel to continue';
          else hintEl.textContent = giftsPendingLabel(giftSlots, giftPicked);
        } else {
          hintEl.hidden = true;
        }
      }
    }

    items.forEach(function (item) {
      var val = item.querySelector('[data-byb3-qval]');
      var inc = item.querySelector('[data-byb3-inc]');
      var max = parseInt(item.getAttribute('data-max'), 10) || 0;
      // Single-quantity items (containers/extras) skip the +/- stepper — the Add button just
      // toggles Add ↔ Added.
      var single = max === 1;
      var addBtn = item.querySelector('[data-byb3-add]');
      var origAddHtml = addBtn ? addBtn.innerHTML : '';
      function syncAddBtn() {
        if (!single || !addBtn) return;
        var on = qtyOf(item) > 0;
        // Same markup shape as the "Added FREE" gift buttons (tick + <span>) for clean alignment.
        addBtn.innerHTML = on ? (gwpTickSvg + '<span>Added</span>') : origAddHtml;
        addBtn.classList.toggle('is-added-btn', on);
      }
      function set(n) {
        n = Math.max(0, n);
        if (max > 0 && n > max) n = max;
        item.setAttribute('data-qty', n);
        if (val) val.textContent = n;
        if (inc) inc.disabled = (max > 0 && n >= max);
        syncAddBtn();
        update();
      }
      function canAdd() {
        if (!isRoleUnlocked(item.getAttribute('data-role'))) return false;
        // Only one container allowed: block adding a second while another is chosen.
        if (item.getAttribute('data-role') === 'container' && qtyOf(item) === 0 && roleQty('container') > 0) return false;
        return true;
      }
      if (addBtn) addBtn.addEventListener('click', function () {
        if (!canAdd()) return;
        // Toggle off if this single-qty item is already added; otherwise add.
        set(single && qtyOf(item) > 0 ? 0 : qtyOf(item) + 1);
      });
      var dec = item.querySelector('[data-byb3-dec]');
      if (dec) dec.addEventListener('click', function () { set(qtyOf(item) - 1); });
      if (inc) inc.addEventListener('click', function () { if (canAdd()) set(qtyOf(item) + 1); });
    });

    // Pick-your-gift toggles — stamp pick order so slots fill in selection order.
    gwpCards.forEach(function (card) {
      var btn = card.querySelector('[data-byb3-gwp-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var nowAdded = !btn.classList.contains('is-added');
        btn.classList.toggle('is-added');
        // Remember a manual removal so auto-pick doesn't immediately re-add it.
        if (nowAdded) { card.setAttribute('data-pick-seq', String(++gwpPickSeq)); card._userRemoved = false; }
        else { card.removeAttribute('data-pick-seq'); card._userRemoved = true; }
        syncGwpBtn(btn);
        update();
      });
    });

    if (subWrap) {
      subWrap.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.addEventListener('change', function () {
          subActive = r.value === 'sub';
          update();
        });
      });
    }

    // Scroll to the first unmet step: the Makeup Wipes group if no wipe yet, else Clean Towels.
    function scrollToFirstStep() {
      // 2+ wipes waive the towel requirement, so it's only "missing" below that.
      var missingRole = roleQty('murw') === 0 ? 'murw' : ((roleQty('towel') === 0 && roleQty('murw') < 2) ? 'towel' : null);
      var target = null;
      if (missingRole) {
        for (var i = 0; i < dividers.length; i++) {
          if (dividers[i]._role === missingRole) { target = dividers[i]; break; }
        }
      }
      if (!target) target = root.querySelector('.byb3-divider') || root.querySelector('[data-byb3-items]');
      if (!target) return;
      var bar = root.querySelector('.byb3-gifts');
      var offset = (bar && getComputedStyle(bar).position === 'sticky') ? bar.offsetHeight + 12 : 12;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (checkoutBtn.disabled) return; // mid-redirect
        if (roleQty('murw') === 0 || (roleQty('towel') === 0 && roleQty('murw') < 2)) {
          scrollToFirstStep();
          return;
        }
        var totalCount = 0;
        items.forEach(function (it) { totalCount += qtyOf(it); });
        // Free gifts are auto-picked and optional, so they no longer block checkout.
        var payload = [];
        // Free Shipping is earned with a Clean Towel OR 2+ wipes. Since the towel may now be
        // skipped, flag the wipe lines with _byb_freeship (parity with _byb_gift) so the server
        // function that grants free shipping can key off it instead of only the towel line.
        var freeShipEarned = roleQty('towel') > 0 || roleQty('murw') >= 2;
        items.forEach(function (it) {
          var n = qtyOf(it);
          var vid = parseInt(it.getAttribute('data-variant-id'), 10);
          if (n > 0 && vid) {
            // Tag each line with its bundle role so the discount function can enforce
            // unlock rules server-side (v1 parity). Luxe Bamboo containers get 'lbb'.
            var bybRole = it.getAttribute('data-role') || 'extra';
            if (bybRole === 'container' && it.getAttribute('data-lbb') === 'true') bybRole = 'lbb';
            var lineProps = { _byb: bybRole };
            if (bundleId) lineProps.Bundle = bundleId;
            if (freeShipEarned && bybRole === 'murw') lineProps._byb_freeship = 'true';
            var line = { id: vid, quantity: n, properties: lineProps };
            // On Subscribe & Save, attach each product's own selling plan (only if it has one).
            if (subActive) {
              var sp = parseInt(it.getAttribute('data-selling-plan'), 10);
              if (sp) line.selling_plan = sp;
            }
            payload.push(line);
          }
        });
        if (!payload.length) return;
        // Add unlocked bar-milestone gifts that carry a variant (e.g. auto bonus gifts).
        // Free gifts are always one-time — never attach a selling plan (v1 parity).
        gifts.forEach(function (g) {
          var vid = parseInt(g.getAttribute('data-gift-variant'), 10);
          if (vid && giftUnlocked(g, totalCount)) payload.push({ id: vid, quantity: 1, properties: giftLineProps() });
        });
        // Add the auto-earned gifts in the fixed spec order — gift #1 DermaDot, then gift #2 Travel.
        var giftOrder = { dermadot: 0, travel: 1 };
        gwpCards.slice().sort(function (a, b) {
          return (giftOrder[giftKeyForRole(a.getAttribute('data-gwp-role'))] || 0) - (giftOrder[giftKeyForRole(b.getAttribute('data-gwp-role'))] || 0);
        }).forEach(function (card) {
          var b = card.querySelector('[data-byb3-gwp-toggle]');
          var vid = parseInt(card.getAttribute('data-gwp-variant'), 10);
          if (b && b.classList.contains('is-added') && vid) {
            payload.push({ id: vid, quantity: 1, properties: giftLineProps() });
          }
        });
        checkoutBtn.disabled = true;
        checkoutBtn.classList.add('is-checkout-redirecting');
        var checkoutLabel = checkoutBtn.querySelector('.byb3-checkout-label');
        if (checkoutLabel) checkoutLabel.textContent = 'Redirecting…';
        setSubDisabled(true);
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: payload })
            });
          })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            // Re-enable the button BEFORE redirecting: if the customer navigates back, the
            // bfcache snapshot would otherwise leave it stuck disabled on "Redirecting…".
            checkoutBtn.classList.remove('is-checkout-redirecting');
            checkoutBtn.disabled = false;
            setSubDisabled(false);
            update();
            window.location.href = discountCode ? ('/discount/' + discountCode + '?redirect=/checkout') : '/checkout';
          })
          .catch(function () {
            checkoutBtn.classList.remove('is-checkout-redirecting');
            checkoutBtn.disabled = false;
            setSubDisabled(false);
            update();
            alert('Sorry, something went wrong. Please try again.');
          });
      });
    }

    update();
  }

  function initAll() { document.querySelectorAll('.byb3').forEach(initV3); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
